import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetShieldCheck: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2l8 4v5c0 5.25-3.5 10-8 12-4.5-2-8-6.75-8-12V6l8-4zm-3 10l2.5 2.5L15 11" />
      </svg>
    </div>
  );
};

export default WidgetShieldCheck;
